<template>
  <el-dialog title="设置面试结果" :visible.sync="dialogVisible" width="40%" :before-close="onClose">
    <div style="line-height: 30px; text-align:left">
      <el-row>
        <el-col :span="4">
          <user-avatar :src="headImage" class="useravatar-cicle-m"></user-avatar>
        </el-col>
        <el-col :span="20">
          <div>{{meName}}</div>
          <div>
            <span v-if="degree">{{degree}}<el-divider direction="vertical"></el-divider></span>
            {{workYear}} 年经验
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          面试职位：
        </el-col>
        <el-col :span="20">{{postName}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          面试轮次：
        </el-col>
        <el-col :span="20">
          第{{interviewRound}}轮
        </el-col>
      </el-row>
    </div>
    <div class="interview-result-wrapper">
      <div style="font-weight: 600; line-height: 24px;">设置结果：</div>
      <el-radio-group v-model="interviewResultId" @change="onChangeInterviewResult">
          <el-row v-for="(item, index) in resultOptions" :key="index">
            <el-radio :label="item.inter_item_id" style="width:250px;">
              {{item.inter_item_text}}
            </el-radio>
          </el-row>
        </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userAvatar from '~/components/UserAvatar';
  import {
    basicInfo,
    interviewResultList,
    setInterviewResult
  } from '~/api/interview';
  export default {
    components: {
      userAvatar
    },
    props: {
      visible: false,
      interviewId: 0,
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
      },
      interviewId(val) {
        this.getInterviewInfo();
      }
    },
    data() {
      return {
        dialogVisible: false,
        meName: '',
        headImage: '',
        degree: '',
        workYear: 0,
        companyName: '',
        postName: '',
        interviewRound: 0,
        interviewStateText: '',
        resultOptions: [],
        interviewResultId: 0,
        resultState: 0,
        loading: false,
      };
    },
    created() {
      this.getInterviewInfo();
      this.getOptionList();
    },
    methods: {
      getInterviewInfo() {
        var params = {
          interviewId: this.interviewId
        };
        basicInfo(params).then(r => {
          if (r.errcode === 0) {
            let data = r.data;
            if (data) {
              this.meName = data.meName;
              this.headImage = data.headImage;
              this.degree = data.degree;
              this.workYear = data.workYear;
              this.companyName = data.companyName;
              this.postName = data.postName;
              this.interviewRound = data.interviewRound;
              this.interviewStateText = data.interviewStateText;
            }
          }
        });
      },
      getOptionList(){
        interviewResultList().then( r => {
          if(r.errcode === 0){
            this.resultOptions = r.data;
          }
        });
      },
      onClose() {
        this.$emit('close');
      },
      onChangeInterviewResult(val){
        let index = this.resultOptions.findIndex(i => i.inter_item_id === val);
        this.resultState = this.resultOptions[index].inter_result_state;
      },
      onConfirm(){
        this.loading = true;
        var params = {
          interview_id: this.interviewId,
          interview_item_id: this.interviewResultId,
          interview_result_state: this.resultState
        };
        setInterviewResult(params).then(m => {
          this.loading = false;
          if (m.errcode == 0) {
            this.$message.success('保存成功');
            if (this.interviewResultId == 62) {
              this.$emit('interview', this.interviewId);
            } else {
              this.$emit('success', this.interviewId);
            }
          } else {
            this.$message.error('保存失败');
          }
        });
      }
    }
  };
</script>

<style scoped>
  
</style>